
  <footer class="main-footer">
    <div class="footer-content">
      <div class="footer-section">
        <strong>User:</strong> {{displayName()()}}
      </div>
      <div class="footer-section">
        <strong>Compañia:</strong> {{companyName()()}}
      </div>
      <div class="footer-section">
        <strong>Copyright &copy; 2024-2025 <a href="https://www.hco-consultores.com/">SMP</a></strong>
      </div>
      <div class="footer-section">
        <strong>SMP Version {{environment.version}}</strong>
      </div>
    </div>
  </footer>
